module.exports = __webpack_public_path__ + "img/logo.e38d0da3.png";